<form [formGroup]="simulationData" class="form-login">
  <div class="card-white blue-dark noMarginMovil pt-40 sumaryContainer">
    <div
      class="flex-container-nowrap w-100 flex-space-between initalContainer no-boder-bottom"
    >
      <div class="titleSumary flex-container-nowrap w-100">
        <b>{{ 'k002781' | translate }}</b>
        <!-- Token: ¿En qué divisa desear realizar la aportación? -->
      </div>
      <select
        name="investCurrency"
        class="12Dig inp investCurrency pointer text-left"
        formControlName="investCurrency"
        (ngModelChange)="changeCurrency($event)"
      >
        <option *ngFor="let currency of currencies" [value]="currency.code">
          {{ currency.code }}
        </option>
      </select>
    </div>
    <div
      class="flex-container-nowrap w-100 flex-space-between initalContainer no-boder-bottom"
    >
      <div class="titleSumary flex-container-nowrap w-100">
        <b>{{ 'k002523' | translate }}</b>
        <!-- Token: What amount do you want to invest initially? -->
      </div>
      <div class="flex-column">
        <input
          id="inicialAmount"
          name="inicialAmount"
          formControlName="inicialAmount"
          class="12Dig inp inicialAmount"
          autonumeric
          #inicialAmount
          [options]="autonumericOptions"
          (keyup)="keyupInitiaAmount($event)"
          (wheel)="mousewheel($event)"
          type="text"
        />
        <small *ngIf="showExchange" class="w-100 text-right">{{
          exchangeTest
        }}</small>
        <small *ngIf="errorMinimun" class="red w-100 text-right"
          >{{ 'k002782' | translate }}
          {{ minimumInvest | trCurrency: baseCurrency:'0.0-0' }}</small
        >
        <!-- token: Cantidad mínima -->
      </div>
    </div>
    <div class="flex-container-nowrap w-100 flex-space-between initalContainer">
      <div class="titleSumary w-100">
        <b>{{ 'k002779' | translate }}</b>
        <!-- Token: Tu banco emisor -->
        <fa-icon
          class="font-15 ml-2 blue2 pointer"
          icon="info-circle"
          (click)="viewHintHelp($event)"
        ></fa-icon>
      </div>
      <input
        matInput
        name="issuingBank"
        class="12Dig inp issuingBank"
        formControlName="issuingBank"
        maxlength="64"
        autocomplete="off"
      />
    </div>
    <div>
      <div class="smallGrey">
        {{ 'k002524' | translate }}
      </div>
    </div>
    <!-- Token: This amount will be saved in our system and once your account is created
      you will receive the required data and details so that you can make the
      transfer and that we can make the acquisition of the portfolio associated
      with your profile. -->
  </div>
</form>
<tech-simulation-init-distribution></tech-simulation-init-distribution>
<tech-simulation-init-fees></tech-simulation-init-fees>
